module.exports = __webpack_public_path__ + "ef5056c58337faba64b86384d9bc9469.svg";